<template>
  <div id="app">
    <head-Back title="新手指引"></head-Back>
    <div class="page">
      <!-- 伪装app的下 -->
      <div class="wz-app">
        <div class="wz-app-desc">
          <p class="desc-title">致用户</p>
          <p class="desc-title-s">（请您仔细阅读以下内容）</p>

          <p class="desc-q">亲爱的用户您好：</p>
          <p class="desc-d">
            &nbsp &nbsp &nbsp &nbsp这是一款熟人社交平台，致力于为您提供一个安全、私密、无干扰的聊天环境。这个产品注定了只是一小部分人的专属私密空间，但我们却因此感到荣幸，因为总要有人去满足小众的需求。 为了您能更好更快的熟悉此产品，
            希望您能耐心了解以下几点：
          </p>
          <!-- <p class="desc-s">1、您只需谨记【好运吧】的官网：<a href="http://www.haoyunba.com">www.haoyunba.com</a>,无论您在何时何地都能在卸载后找回软件并体验我们持续不断更新的各类伪装APP。</p> -->
          <p class="desc-s">1、我们承诺不会用任何通讯方式主动联系你，以确保您的聊天足够隐蔽。</p>
          <p class="desc-s">
            2、无论是您还是我们运营团队，都不希望这款产品像微信、钉钉一样被大规模的人使用和知道。因此我们不会进行大规模的商业广告推广，我们将时刻控制用户规模，优化体验，将产品发展成为私密、会员制
            的优质社交产品。
          </p>
          <p class="desc-d">&nbsp &nbsp &nbsp &nbsp 再次感谢您使用我们的产品，希望您在这聊天愉快！</p>
          <p class="desc-t">好运吧运营团队</p> 
        </div>

        <!-- <ul>
          <li>
            <img src="../../assets/img/logo-jsq.png" alt />
            <p>计算器APP</p>
          </li>
          <li>
            <img src="../../assets/img/logo-txs.png" alt />
            <p>资讯APP</p>
          </li>
          <li class="mar-to">
            <img src="../../assets/img/logo-xxl.png" alt />
            <p>学习乐APP</p>
          </li>
        </ul>
        <div class="wz-app-down befer-app-down" @click="downapp()">下载更多APP></div>
        <div class="wz-app-hr"></div>-->
      </div>

      <!-- 亲密聊app的下 -->
      <!-- <div class="xz-mian">
        <div class="xz-mian-qml">
          <img src="../../assets/img/logo-qml.png" alt />
          <p>亲密聊APP</p>
        </div>
        <div class="xz-app-down befer-app-down" @click="downappQml()">立即下载亲密聊></div>
      </div>-->

      <!-- 如何使用 -->
      <div class="use-reg">
        <div class="use-reg-title">注册后如何使用？</div>


        <div class="use-reg-title">1、如何添加好友</div>
        <div class="use-reg-desc">
          <p>① 点击<span>通讯录</span>-<span>添加好友</span>-<span>通过微信或者短信</span>将<span>注册链接</span>分享给好友注册 </p>
          <p>② 当你的好友注册成功登陆后，你们可以搜索对方的聊天号或者扫描对方二维码添加成为好友</p>
        </div>
        <div
          class="use-reg-app-down youtube-app-down"
          @click="openViveo('http://img.haoyunba.com/tjmy.mp4')"
        >查看演示视频></div>


        <div class="use-reg-title">2、聊天号的作用</div>
        <div class="use-reg-desc">
          <p>注册即可获得10个聊天号，相当于拥有10个微信号</p>
          <p> 每个聊天号相互独立，密码不同</p>
          <p>使用手机号+聊天号的密码可以登录我们任意伪装APP</p>
        </div>

        <div class="use-reg-title">3、密码的作用</div>
        <div class="use-reg-desc">
          <p>密码是您进入聊天界面的唯一手段 </p>
          <p>以防您的手机遗失被人重置密码而导致私暴露，<span>产品不设密码找回</span>，所以<span>请您牢记密码</span></p>
        </div>
        <!-- <div
          class="use-reg-app-down youtube-app-down"
          @click="openViveo('http://img.haoyunba.com/dr.mp4')"
        >查看演示视频></div> -->

        

        <div class="use-reg-title">4、伪装推送：</div>
        <div class="use-reg-desc">
          <p>不同伪装APP的消息提醒是不一样的</p>
          <p>比如：计算器的消息提醒是提醒你更新新版本；资讯类的消息提供是新闻推送</p>
          <p><span>伪装推送</span>其实是告诉你<span>有重要的人给您发消息了</span></p>

        </div>
        <div
          class="use-reg-app-down youtube-app-down"
          @click="openViveo('http://img.haoyunba.com/wzts.mp4')"
        >查看演示视频></div>

        <!-- <div class="use-reg-title ma">
          光明正大地伪装！
          <div
            class="xzapp-down youtube-app-down-s"
            @click="openViveo('http://img.haoyunba.com/wzts.mp4')"
          >查看演示视频></div>
        </div> -->
      </div>

      <!-- 伪装app的下 -->
      <!-- <div class="wz-app vip-app">
        <ul>
          <li>
            <img src="../../assets/img/logo-jsq.png" alt />
            <p>计算器APP</p>
          </li>
          <li>
            <img src="../../assets/img/logo-txs.png" alt />
            <p>资讯APP</p>
          </li>
          <li>
            <img src="../../assets/img/logo-xxl.png" alt />
            <p>学习乐APP</p>
          </li>
          <li>
            <img src="../../assets/img/logo-clac.png" altw />
            <p>安卓各手机同款计算器APP</p>
          </li>
          <li>
            <img src="../../assets/img/logo-xw.png" alt />
            <p>多种名称和外壳资讯APP</p>
          </li>
        </ul>
        <div class="wz-app-down vip-app-down befer-app-down" @click="downapp()">下载更多APP></div>
        <div class="wz-app-hr"></div>
      </div> -->

      <!-- VIP功能 -->
      <div class="vip-gong">
        <div class="vip-gong-title">VIP功能</div>
        <ul>
          <li>VIP功能</li>
          <li>贴心的效果</li>

          <li>一键返回浮窗</li>
          <li>
            <span class="right-desc">突发情况，一键返回</span>
            <button
              @click="openViveo('http://img.haoyunba.com/yijianfanhuiweizhuangyemian.mp4')"
            >演示></button>
          </li>
          <li>翻转返回</li>
          <li>
            <span class="right-desc">翻转手机即可紧急伪装</span>
            <button  @click="openViveo('http://img.haoyunba.com/fzfanhui.mp4')"
            >演示></button>
          </li>

          <li>不需要伪装外壳</li>
          <li>
            <span class="right-desc">无需输密码，直接去聊天</span>
            <button
              @click="openViveo('http://img.haoyunba.com/buxuyaoweizhuangwaikegongneng.mp4')"
            >演示></button>
          </li>

          <li>定时自动返回</li>
          <li>
            <span class="right-desc">有效避免酒后泄露隐私</span>
            <button @click="openViveo('http://img.haoyunba.com/zidongfanhuigongneng.mp4')">演示></button>
          </li>

          <li>同步聊天记录</li>
          <li>
            <span class="right-desc">长达2年，留住亲密时光</span>
            <button @click="openViveo('http://img.haoyunba.com/tongbuliaotianjilu.mp4')">演示></button>
          </li>

          <li>保密时段</li>
          <li>
            <span class="right-desc">保密时间，无人可进入</span>
            <button @click="openViveo('http://img.haoyunba.com/baomisiduangongneng.mp4')">演示></button>
          </li>

          
        </ul>
      </div>

      <!-- VIP费用 -->
      <div class="vip-gong vip-fei">
        <div class="vip-gong-title">VIP费用</div>
        <ul>
          <li style="color:#FFF" >VIP等级</li>
          <li style="color:#FFF"  >VIP价格</li>
          
          <!-- <li style="background:#FFF" >永久VIP <img src="../clac/img/fada.png" ></li>
          <li style="background:#FFF">
            <div class="ry">1398元</div>
            <div class="yy">5200</div>
          </li>

          <li>一年VIP <img src="../clac/img/fada.png" ></li>
          <li>
            <div class="ry">999元</div>
            <div class="yy">1999</div>
          </li>

          <li>六个月VIP <img src="../clac/img/fada.png" ></li>
          <li>
            <div class="ry">518元</div>
            <div class="yy">1188</div>
          </li>

          <li>三个月VIP <img src="../clac/img/fada.png" ></li>
          <li>
            <div class="ry">288元</div>
            <div class="yy">588</div>
          </li>

          <li>一个月VIP</li>
          <li>
            <div class="ry">98元</div>
            <div class="yy">199</div>
          </li> -->
            <div  v-for="(item ,index) in vipdata ">
               <li class="vip-gong-name" style="background:#FFF"  >
                {{ item.name }}
                <img  v-show="item.st == 1" src="../clac/img/bysy.png" />
              </li>
              <li class="vip-gong-fei" style="background:#FFF" >
                <div class="ry"  v-show="!iosflag" >{{ item.price }}</div>
                <div class="ry" v-show="iosflag" >{{ item.aprice }}</div>

                <div class="yy">  {{ item.yprice }}</div>
                   <img  v-show="item.st == 1 && item.cmtimg != '' " :src="item.cmtimg" />
              </li>
         </div>
        </ul>
        <div class="vip-yong-text">
          买一送一：你买VIP，你的好友也可获得同等VIP。
        </div>
      </div>
    </div>
    <div class="qa" @click="toqa()"></div>

    <div  v-show="flag" class="foot" @click="toPay()">立即购买VIP</div>
    <div v-show="!flag" class="foot" >祝你聊天愉快</div>


    <videoVue ref="videoVue"></videoVue>
  </div>
</template>
<script>
import headBack from "../common/head-back";
import videoVue from "../common/video";
import util from "@/utils/util";
import store from "../../store/index";
import * as types from "../../store/types";
import { mapGetters } from "vuex";
import api from "../../api/index";
import tips from "@/estoast";


export default {
  metaInfo: {
    title: "新手指引"
  },
  name: "app",
  data() {
    return {
      msg: "新手指引",
      userInfo: {},
      flag:false,
         vipdata:[
        {"name":"永久VIP","price":999,"aprice":1298,"yprice":5200,st:1,cmtimg:"../../../static/img/n-vip3.png"},
        {"name":"一年VIP","price":798,"aprice":1098,"yprice":1999,st:1,cmtimg:""},
        {"name":"六个月VIP","price":398,"aprice":588,"yprice":1188,st:1,cmtimg:"../../../static/img/n-vip2.png"},
        {"name":"三个月VIP","price":218,"aprice":288,"yprice":588,st:0,cmtimg:""},
        {"name":"一个月VIP","price":98,"aprice":128,"yprice":199,st:0,cmtimg:""}

      ],
      list: [],
      iosflag:true,

      videoUrl: "http://img.haoyunba.com/tjmy.mp4",
    };
  },
  mounted() {
    this.userInfo = this.getUserInfo;
    console.log("用户信息"+JSON.stringify(+this.userInfo ))
    if(this.userInfo == null){
      flag = true;
    }
     var ua = navigator.userAgent;
    if (ua.indexOf("T00991") > -1) {
      this.iosflag = true;          
    }else{
      this.iosflag = false;          
    }

  },
  methods: {
    openViveo(a) {
      console.log("父组件url:" + a);
      this.$refs.videoVue.openTan(a);
    },
    toPay: function() {
      this.$router.push("/pay");
    },
    downappQml() {
      this.$router.push("/qmlResult");
    },
    downapp: function() {
      this.$router.push("/downapp");
    },
    toqa: function() {
      var ua = navigator.userAgent;
      // if (ua.indexOf("T00991") > -1) {
      //    this.$router.push("/questionios");      
      // }else{
      //   this.$router.push("/question");        
      // }
      this.$router.push("/questionios");      
     
    }
  },
  components: {
    headBack,
    videoVue
  },
   computed: {
    ...mapGetters([
      "getWxAlert",
      "loading",
      "getUserInfo",
      "getToken",
      "getUserList"
    ])
  }
};
</script>
<style  scoped>
#app {
  height: 1344px;
  width: 750px;
}
.page {
  background: url("./img/back-1.png");
  background-size: 100% 100%;
  width: 750px;
  height: 4651px;
}

.wz-app {
  height: 200px;
  width: 647px;
  top: 510px;
  margin: 0 auto;
  position: relative;
}

.wz-app ul {
  padding: 0;
  margin: 0;
  width: 100%;
  height: auto;
}
.wz-app ul li {
  padding: 0;
  margin: 0;
  height: 200px;
  float: left;
  width: 160px;
  list-style: none;
}
.wz-app ul li img {
  width: 116px;
  height: 116px;
  background: rgba(248, 255, 255, 1);
  box-shadow: 0px 0px 20px 5px rgba(166, 220, 239, 0.3);
  border-radius: 26px;
}

.wz-app ul li p {
  padding: 0;
  margin: 5px 0 0 0;
  width: 100%;
  height: 46px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(102, 86, 91, 1);
  line-height: 36px;
}
.wz-app ul li:nth-child(2) {
  float: left;
  margin-left: 80px;
}
.wz-app ul li:nth-child(3) {
  float: right;
  /* margin-top: -25px; */
}
.wz-app-down {
  width: 100%;
  height: 25px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  border: none;
  float: right;
  text-align: right;
  margin-top: 10px;
}

.befer-app-down::before {
  content: " ";
  width: 24px;
  height: 24px;
  font-size: 24px;
  position: absolute;
  font-weight: normal;
  color: rgba(40, 119, 227, 1);
  background: url("../../assets/img/download.png");
  background-size: 100% 100%;
  margin-left: -30px;
}
.youtube-app-down::before {
  content: " ";
  width: 27px;
  height: 18px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  position: absolute;
  font-weight: normal;
  color: rgba(40, 119, 227, 1);
  background: url("../../assets/img/youtube.png");
  background-size: 100% 100%;
  margin-left: -30px;
  margin-top: 10px;
}

.youtube-app-down-s::before {
  content: " ";
  width: 27px;
  height: 18px;
  font-size: 24px;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  position: absolute;
  font-weight: normal;
  color: rgba(40, 119, 227, 1);
  background: url("../../assets/img/youtube.png");
  background-size: 100% 100%;
  margin-left: -30px;
  margin-top: 38px;
}

.wz-app-hr {
  width: 100%;
  height: 3px;
  background: rgba(176, 227, 246, 1);
  opacity: 0.3;
  position: relative;
  float: right;
  margin: 30px auto 0px;
}
.xz-mian {
  height: 200px;
  width: 603px;
  top: 1030px;
  margin: 0 auto;
  position: relative;
}

.xz-mian-qml {
  width: 450px;
  height: 200px;
  margin: 0px auto 0;
}

.xz-mian-qml img {
  width: 116px;
  height: 116px;
  background: rgba(248, 255, 255, 1);
  box-shadow: 0px 0px 20px 5px rgba(166, 220, 239, 0.3);
  border-radius: 26px;
}

.xz-mian-qml p {
  width: 100%;
  height: 10px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(102, 86, 91, 1);
}
.xz-app-down {
  width: 100%;
  height: 25px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  margin-top: 80px;
  float: right;
  text-align: right;
}
.use-reg {
  width: 653px;
  height: 1233px;
  top: 1125px;
  margin: 0 auto;
  position: relative;
}
.use-reg-title {
  width: 99%;
  font-size: 34px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(227, 99, 135, 1);
  text-align: left;
  line-height: 90px;
  margin-left: 10px;
}
.use-reg-desc {
  width: 617px;
  margin: 0 auto;
  height: auto;
  font-size: 24px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #76646A;
  text-align: left;
}

.use-reg-desc p {
  padding: 0;
  margin: 0;
  line-height: 50px;
}

.use-reg-desc p span{
  font-weight: 500px;
  color: #1070F0;
}

.use-reg-app-down {
  width: 100%;
  height: 25px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  text-align: right;
  margin-right: 80px;
}
.xzapp-down {
  width: 205px;
  height: 25px;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(40, 119, 227, 1);
  text-align: right;
  float: right;
  margin: 0px 0px 0 0;
}
.ma {
  margin-top: 40px;
}

.vip-app {
  top: 1672px;
  height: 400px;
}
.vip-app-down {
  width: 100%;
  text-align: right;
  margin-top: 30px;
}

.vip-app ul li:nth-child(4) {
  margin-top: 20px;
  margin-left: 120px;
}
.vip-app ul li:nth-child(5) {
  margin-top: 20px;
  margin-left: 80px;
}
.vip-gong {
  width: 683px;
  height: 601px;
  margin: 1930px auto 0px;
}

.vip-gong-title {
  height: 34px;
  font-size: 36px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(40, 119, 227, 1);
  text-align: left;
  margin-left: 20px;
}

.vip-gong ul {
  width: 93%;
  height: 56px;
  margin: 40px auto 0px;
  padding: 0;
}

.vip-gong ul li {
  float: left;
  list-style: none;

  width: 49%;
  height: 60px;
  line-height: 56px;
}
.vip-gong ul li:nth-child(2n + 1) {
  width: 28%;
  text-align: center;
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(21, 123, 250, 1);
  border-bottom: 1px solid rgba(21, 123, 250, 1);
  border-left: 1px solid rgba(21, 123, 250, 1);
}
.vip-gong ul li:nth-child(2n) {
  width: 70%;
  text-align: left;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(118, 100, 106, 1);
  border-bottom: 1px solid #8db7f0;
  border-left: 1px solid #8db7f0;
  border-right: 1px solid #8db7f0;
}

.vip-gong-name {
  width: 28%;
  text-align: center;
  font-size: 25px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(21, 123, 250, 1);
  border-bottom: 1px solid rgba(21, 123, 250, 1);
  border-left: 1px solid rgba(21, 123, 250, 1);
}

.vip-gong-fei {
  width: 70%;
  text-align: left;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(118, 100, 106, 1);
  border-bottom: 1px solid #8db7f0;
  border-left: 1px solid #8db7f0;
  border-right: 1px solid #8db7f0;
}

.right-desc {
  font-size: 24px;
  margin-left: 25px;
}
.vip-gong ul li button {
  width: 109px;
  height: 40px;
  background: rgba(21, 123, 250, 1);
  border-radius: 20px;
  border: none;
  float: right;
  color: rgba(255, 255, 255, 1);
  margin: 8px 15px 0 0;
}

.vip-gong ul li:nth-child(1) {
  width: 28%;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  background: rgba(21, 123, 250, 1);
  border-bottom: 1px solid rgba(21, 123, 250, 1);
  border-left: 1px solid rgba(21, 123, 250, 1);
}
.vip-gong ul li:nth-child(2) {
  width: 70%;
  font-size: 26px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  background: rgba(21, 123, 250, 1);
  border-bottom: 1px solid rgba(21, 123, 250, 1);
  border-left: 1px solid #8db7f0;
  border-right: 1px solid rgba(21, 123, 250, 1);
}

.vip-fei {
  height: 501px;
  margin: 30px auto 0px;
}

.vip-fei ul {
  width: 492px;
}

.vip-fei ul li {
  text-align: center;
  font-size: 26px;
  width: 48%;
}


.vip-gong-name  img{
  position: relative;
  width: 64px;
  height: 22px;
  display: block;
  top: -56px;
  left: 178px;
}

.vip-gong-fei img{
   width: 104px;
   height: 21px;
   margin-top: -5px;
  position: relative;
  display: block;
  top: -64px;
  left: 138px;
}


.vip-fei ul li .ry {
  width: 153px;
  height: 100%;
  float: left;
  text-align: right;
}
.vip-fei ul li .yy {
  width: 73px;
  height: 100%;
  float: left;
  text-align: left;
   font-size: 16px;
  text-indent: 10px;
  display: block;
  text-decoration: line-through;
  line-height: 65px;
}

.vip-fei ul li:nth-child(2n + 1) {
  width: 49%;
  text-align: center;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(21, 123, 250, 1);
  border-bottom: 1px solid #8db7f0;
  border-left: 1px solid #8db7f0;
}
.vip-fei ul li:nth-child(2n) {
  width: 49%;
  text-align: center;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 400;
  color: rgba(118, 100, 106, 1);
  border-bottom: 1px solid #8db7f0;
  border-left: 1px solid #8db7f0;
  border-right: 1px solid #8db7f0;
}

.vip-fei-ul-first {
  width: 49%;
  font-size: 26px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  background: rgba(21, 123, 250, 1);
  border-bottom: 1px solid #8db7f0;
  border-left: 1px solid rgba(21, 123, 250, 1);
}
.vip-fei-ul-secode {
  width: 49%;
  font-size: 26px;
  text-align: center;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(255, 255, 255, 1);
  background: rgba(21, 123, 250, 1);
  border-bottom: 1px solid #8db7f0;
  border-left: 1px solid #8db7f0;
  border-right: 1px solid rgba(21, 123, 250, 1);
}

.foot {
  width: 100%;
  height: 95px;
  background: linear-gradient(
    0deg,
    rgba(45, 80, 237, 1) 0%,
    rgba(78, 160, 254, 1) 100%
  );
  position: fixed;
  bottom: 0;
  border: none;
  font-size: 38px;
  font-family: PingFang SC;
  font-weight: 600;
  color: rgba(249, 245, 254, 1);
  line-height: 95px;
}

.qa {
  background: url("../../assets/img/QA.png");
  background-size: 100% 100%;
  width: 123px;
  height: 123px;
  border-radius: 50%;
  position: fixed;
  bottom: 130px;
}

.desc-title {
  font-size: 32px;
  font-family: PingFang SC;
  font-weight: 800;
  color: rgba(228, 99, 136, 1);
  text-align: center;
  line-height: 41px;
}
.desc-title-s {
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: rgba(228, 99, 136, 1);
  text-align: center;
  line-height: 41px;
}

.desc-q {
  text-align: left;
  line-height: 38px;
  font-weight: 700;
}

.desc-s {
  text-align: left;
  line-height: 41px;
  text-indent:2em;

}
.desc-s::before {
  background: rgba(255, 127, 0, 1);
  position: absolute;
  content: "";
  width: 21px;
  height: 21px;
  margin-left: -35px;
  margin-top: 8px;
  border-radius: 21px;
}

.desc-d {
  text-align: left;
  line-height: 41px;
}

.desc-t {
  text-align: right;
  line-height: 58px;
  font-weight: 700;
}

.wz-app-desc p {
  margin: 0;
  padding: 0;
}
.wz-app-desc a{
  color: #1070F0;
  text-decoration: none;
  
}

.wz-app-desc {
  width: 100%;
  height: 803px;
  color: #76646a;
  font-size: 21px;
  text-align: left;
}
.vip-yong-text{
  width: 487px;
  height: 21px;
  font-size: 20px;
  font-family: PingFang SC;
  font-weight: 500;
  color: #76646A;
  text-align: center;
  margin: 330px auto 0 auto;
}
</style>


// WEBPACK FOOTER //
// src/components/clac/noviceguideios.vue